import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Heart, Lock } from "lucide-react";
import { useAuth } from "../lib/auth";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    if (user && user.role === "admin") {
        return <Navigate to="/admin" replace />;
    }

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const data = await login(email, password);
            if (data.role !== "admin") {
                setError("Admin access required");
            } else {
                navigate("/admin");
            }
        } catch (err) {
            const detail = err.response?.data?.detail;
            setError(typeof detail === "string" ? detail : "Login failed");
        }
        setLoading(false);
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-12" data-testid="admin-login-page">
            <div className="w-full max-w-md">
                <div className="text-center mb-10">
                    <div className="inline-flex w-14 h-14 rounded-full bg-femcare-pink items-center justify-center mb-6">
                        <Heart className="w-7 h-7 text-white" fill="white" strokeWidth={0} />
                    </div>
                    <h1 className="editorial-headline text-4xl text-femcare-purple mb-2">Admin Sign In</h1>
                    <p className="text-sm text-femcare-purple/60">Manage content, view stats, and read messages.</p>
                </div>

                <form onSubmit={submit} className="bg-white border border-femcare-border rounded-3xl p-8 space-y-5">
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-femcare-accent block mb-2">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full bg-femcare-cream border border-femcare-border rounded-xl px-4 py-3 focus:outline-none focus:border-femcare-pink"
                            data-testid="admin-email"
                        />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-femcare-accent block mb-2">Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full bg-femcare-cream border border-femcare-border rounded-xl px-4 py-3 focus:outline-none focus:border-femcare-pink"
                            data-testid="admin-password"
                        />
                    </div>
                    {error && <p className="text-sm text-red-600" data-testid="admin-error">{error}</p>}
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full btn-primary justify-center disabled:opacity-50"
                        data-testid="admin-submit"
                    >
                        <Lock className="w-4 h-4" />
                        {loading ? "Signing in..." : "Sign In"}
                    </button>
                </form>
            </div>
        </div>
    );
}
